export default __webpack_public_path__ + "static/media/not-found-page.acb74830.webp";